__turbopack_context__.v({
  "bottomShadow": "LogosGrid-module-scss-module__6eYazW__bottomShadow",
  "btn": "LogosGrid-module-scss-module__6eYazW__btn",
  "cell": "LogosGrid-module-scss-module__6eYazW__cell",
  "expanded": "LogosGrid-module-scss-module__6eYazW__expanded",
  "grid": "LogosGrid-module-scss-module__6eYazW__grid",
  "gridContainer": "LogosGrid-module-scss-module__6eYazW__gridContainer",
  "header": "LogosGrid-module-scss-module__6eYazW__header",
  "logo": "LogosGrid-module-scss-module__6eYazW__logo",
  "root": "LogosGrid-module-scss-module__6eYazW__root",
  "subheader": "LogosGrid-module-scss-module__6eYazW__subheader",
});
